var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.132945 6.73801C0.114966 6.70482 0.0947752 6.67329 0.0803919 6.63816C0.065732 6.60303 0.0574341 6.56652 0.0469236 6.53056C0.0380726 6.50041 0.0264559 6.47165 0.0203705 6.44067C-0.0067358 6.30376 -0.0067358 6.16297 0.0203705 6.02633C0.0264559 5.99535 0.0380726 5.96659 0.0466471 5.93671C0.0574341 5.90048 0.065732 5.86397 0.0803919 5.82856C0.0947752 5.79371 0.11469 5.76218 0.132668 5.72927C0.147605 5.70161 0.159775 5.67312 0.177477 5.64656C0.2162 5.58876 0.260179 5.53454 0.309136 5.48531L5.4848 0.309926C5.89803 -0.103309 6.56767 -0.103309 6.9809 0.309926C7.39386 0.722883 7.39386 1.3928 6.9809 1.80576L3.61086 5.17552H11.7558C12.3399 5.17552 12.8135 5.64905 12.8135 6.2335C12.8135 6.81767 12.3399 7.2912 11.7558 7.2912H3.61086L6.9809 10.661C7.39386 11.0742 7.39386 11.7438 6.9809 12.1571C6.56767 12.57 5.89803 12.57 5.4848 12.1571L0.309136 6.98141C0.260179 6.93218 0.2162 6.87797 0.177477 6.82016C0.160051 6.79388 0.147882 6.76539 0.132945 6.73801Z",
    fill: "#3D3F43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left_arrow_icon.bb1dca0dc54352308a89b6353007df50.svg";
export { ForwardRef as ReactComponent };